import React from 'react';

const Search: React.FC<React.PropsWithChildren> = () => (
  <path d="M5.29341 0.187744C7.68412 0.187744 9.62441 2.12803 9.62441 4.51875C9.62441 6.90946 7.68412 8.84976 5.29341 8.84976C2.90269 8.84976 0.962402 6.90946 0.962402 4.51875C0.962402 2.12803 2.90269 0.187744 5.29341 0.187744ZM5.29341 7.88731C7.1543 7.88731 8.66197 6.37964 8.66197 4.51875C8.66197 2.65738 7.1543 1.15019 5.29341 1.15019C3.43204 1.15019 1.92485 2.65738 1.92485 4.51875C1.92485 6.37964 3.43204 7.88731 5.29341 7.88731ZM9.37658 7.92148L10.738 9.28237L10.057 9.9633L8.69613 8.60193L9.37658 7.92148Z" />
);

export default Search;
